import React, { createRef, useEffect, useState } from "react";

import "./piecePreview.css";
import { getApiUrl } from "../../data/api/apiManager";
import Button from "../button";
import EyeIcon from "../../assets/icons/eyeIcon";
import PDFPreviewPopUp from "../pdfPreviewPopUp";
import FullscreenIcon from "../../assets/icons/fullscreenIcon";

interface PiecePreviewProps {
    thumbnailHash: string;
    previewHash?: string;
    fixedAspectRatio?: number;
    children?: any;
    placeholder?: boolean;
}

export default function PiecePreview(props: PiecePreviewProps) {

    const [previewFullscreen, setPreviewFullscreen] = useState(false);

    const ref = createRef<HTMLDivElement>();
    const [height, setHeight] = useState<string>("");

    useEffect(() => {
        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => {
            window.removeEventListener("resize", updateHeight);
        };
    });

    function updateHeight() {
        setHeight(props.fixedAspectRatio ? ((ref.current?.offsetWidth ? ref.current.offsetWidth : 0) * props.fixedAspectRatio) + "px" : "");
    }
    
    return <div ref={ref} style={{
            height: height
        }} className={"piece-preview" + (props.placeholder ? " placeholder": "")}>
            {props.children}
        {props.placeholder ? <>
            <h2>+</h2>
            <a>Add piece</a>
        </> : <img itemProp="image" src={getApiUrl("assets/by-hash/" + props.thumbnailHash)} alt="Score Preview"/>}

        {props.previewHash && <div className="fullscreen-preview" onClick={() => {
            setPreviewFullscreen(!previewFullscreen);
        }}>
            <FullscreenIcon/>
        </div>}
        {props.previewHash && <PDFPreviewPopUp setOpen={setPreviewFullscreen} open={previewFullscreen} url={getApiUrl("assets/by-hash/" + props.previewHash)}/>}
    </div>

}